const styles = (theme) => ({
  image: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: theme.shape.borderRadius,
  },
  actionArea: {
    height: '150px',
    '&:before': {
      position: 'absolute',
      top: '0',
      width: '100%',
      height: '100%',
      content: '""',
      opacity: '0',
      transitionDuration: 300,
      borderRadius: theme.shape.borderRadius,
    },
    '&:hover:before': {
      opacity: '0.1',
      backgroundColor: theme.palette.common.black,
    },
  },
});

export default styles;
